import { Component, OnInit, EventEmitter } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BamboraPaymentCardService } from '../../../providers/bambora-payment-card.service';
import { PersonService } from '../../../providers/person.service';
import { Bambora_credit_card } from '../../../models/accounting/banking/bambora_credit_card';
import { Person } from '../../../models/person';
import { ModalChoosePersonComponent } from '../../people/modal-choose-person/modal-choose-person.component';
import { ModalAddPersonComponent } from '../../people/modal-add-person/modal-add-person.component';
import { SmsAbstractAppPage } from '../../sms-abstract-app-page';
import { faSave, faUser, faAt, faPhoneSquare, faCreditCard } from '@fortawesome/pro-regular-svg-icons';

class Card_model {
	cardholder_name: string;
	cardnumber: string;
	cvv: string;
	month: string;
	year: string;
	address: string;
	city: string;
	province: string;
	postal_code: string;
	country: string;
	email: string;
	phone: string;
	user_person_id: string;

	constructor() {
		this.cardholder_name = '';
		this.cardnumber = '';
		this.cvv = '';
		this.month = '';
		this.year = '';
		this.address = '';
		this.city = '';
		this.province = '';
		this.postal_code = '';
		this.country = 'CA';
		this.email = '';
		this.phone = '';
		this.user_person_id = '';
	}
}

@Component({
	standalone: false,
	selector: 'app-bambora-modal-add-payment-method',
	templateUrl: './bambora-modal-add-payment-method.component.html',
	styleUrls: ['./bambora-modal-add-payment-method.component.css']
})
export class BamboraModalAddPaymentMethodComponent extends SmsAbstractAppPage implements OnInit {

	faSave = faSave;
	faUser = faUser;
	faAt = faAt;
	faPhoneSquare = faPhoneSquare;
	faCreditCard = faCreditCard;

	organizer_id: string = '';

	credit_card_created$: EventEmitter<Bambora_credit_card> = new EventEmitter<Bambora_credit_card>();
	card_model = new Card_model();
	associated_person: Person = new Person({});

	constructor(
		public activeModal: NgbActiveModal,
		private modal: NgbModal,
		private bamboraPaymentCardService: BamboraPaymentCardService,
		private personService: PersonService
	) {
		super();
	}

	ngOnInit() { }

	onSubmit() {
		if (this.card_model.cardholder_name === '') {
			this.handleError('Cardholder name must have a value!');
			return;
		}
		if (this.card_model.cardnumber === '') {
			this.handleError('Card # must have a value!');
			return;
		}
		if (this.card_model.cvv === '') {
			this.handleError('CVV must have a value!');
			return;
		}
		if (this.card_model.month === '') {
			this.handleError('Month must have a value!');
			return;
		}
		if (this.card_model.year === '') {
			this.handleError('Year must have a value!');
			return;
		}
		if (this.card_model.address === '') {
			this.handleError('Address must have a value!');
			return;
		}
		if (this.card_model.city === '') {
			this.handleError('City must have a value!');
			return;
		}
		if (this.card_model.province === '') {
			this.handleError('Province must have a value!');
			return;
		}
		if (this.card_model.postal_code === '') {
			this.handleError('Postal code must have a value!');
			return;
		}
		if (this.card_model.phone === '') {
			this.handleError('Phone must have a value!');
			return;
		}
		if (this.card_model.email === '') {
			this.handleError('Email must have a value!');
			return;
		}
		if (this.associated_person.id === undefined) {
			this.handleError('You must choose an associated person with this payment method!');
			return;
		}

		this.card_model.user_person_id = this.associated_person.id;

		this.bamboraPaymentCardService.create(this.organizer_id, this.card_model).then(credit_card => {
			this.credit_card_created$.emit(credit_card);
		}).catch(error => {
			this.handleError(error);
		});
	}

	handleChoosePerson() {
		const modal_ref = this.modal.open(ModalChoosePersonComponent, { size: 'lg' });
		modal_ref.componentInstance.role = 'PERSON ASSOCIATED W/ PAYMENT METHOD';

		modal_ref.componentInstance.add_new_selected$.subscribe(() => {
			modal_ref.close();
			this.handleAddPerson();
		}, error => {
			this.handleError(error);
		});

		modal_ref.componentInstance.person_selected$.subscribe((selected_person: Person) => {
			modal_ref.close();
			this.associated_person = selected_person;
			this.card_model.cardholder_name = selected_person.first_name + ' ' + selected_person.last_name;
		});
	}

	handleAddPerson() {
		const modal_ref = this.modal.open(ModalAddPersonComponent, { size: 'lg' });
		modal_ref.componentInstance.person = new Person({});

		modal_ref.componentInstance.person_saved$.subscribe((new_person: Person) => {
			modal_ref.close();
			this.personService.create(new_person).then(person => {
				this.associated_person = person;
				this.card_model.cardholder_name = person.first_name + ' ' + person.last_name;
			}, error => {
				this.handleError(error);
			});
		});
	}

}
